import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import TransportService from "./transportService";


export const getTransports = createAsyncThunk("Transport/get-Transports", async (thunkAPI) => {
  try {
    return await TransportService.getTransports();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createTransports = createAsyncThunk(
  "Transport/create-Transports",
  async (TransportData, thunkAPI) => {
    try {
      return await TransportService.createTransports(TransportData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getTransport = createAsyncThunk(
  "Transport/get-Transport",
  async (id, thunkAPI) => {
    try {
      return await TransportService.getTransport(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateTransport = createAsyncThunk(
  "Transport/update-Transport",
  async (brand, thunkAPI) => {
    try {
      return await TransportService.updateTransport(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteATransport = createAsyncThunk(
  "Transport/delete-Transport",
  async (id, thunkAPI) => {
    try {
      return await TransportService.deleteTransport(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Transports: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const TransportSlice = createSlice({
  name: "Transport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTransports.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTransports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Transports = action.payload.data;
      })
      .addCase(getTransports.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createTransports.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createTransports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdTransport = action.payload;
      })
      .addCase(createTransports.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getTransport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTransport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.associationtype = action.payload.data.type;
        state.associationshortName= action.payload.data.shortName;
        state.associationemail= action.payload.data.email;
        state.associationName= action.payload.data.name;
        
       
        
        
        
      })
      .addCase(getTransport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateTransport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateTransport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedTransport = action.payload;
      })
      .addCase(updateTransport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteATransport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteATransport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedTransport = action.payload;
      })
      .addCase(deleteATransport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default TransportSlice.reducer;
